import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { CHART_VIEW_OPTIONS } from './useChartView';

export function ChartViewSelector({ value, onChange, disabled = false, options = CHART_VIEW_OPTIONS }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const selected = options.find((option) => option.value === value) || options[0];

  return (
    <div
      ref={ref}
      className="relative"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Chart view"
        onClick={() => !disabled && setOpen((isOpen) => !isOpen)}
        className={`flex h-8 min-w-[118px] items-center justify-between gap-2 rounded-lg border px-2.5 text-[12px] shadow-[0_2px_8px_rgba(15,23,42,0.08)] transition-colors ${
          disabled
            ? 'cursor-not-allowed border-slate-100 bg-slate-50 text-slate-400'
            : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50'
        }`}
      >
        <span className="truncate">{selected.label}</span>
        <ChevronDown className={`h-3.5 w-3.5 flex-shrink-0 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && !disabled && (
        <div
          role="listbox"
          aria-label="Chart view options"
          className="absolute right-0 top-full z-50 mt-1 min-w-full rounded-lg border border-slate-200 bg-white py-1 shadow-lg"
        >
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              role="option"
              aria-selected={option.value === value}
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
              className={`flex w-full items-center px-3 py-2 text-left text-[12px] transition-colors hover:bg-slate-50 ${
                option.value === value ? 'font-semibold text-[#201C35]' : 'text-slate-700'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
